'use client'

import { useRowLabel } from '@payloadcms/ui'

export const AdminMenusRowLabel = () => {
  const { data, rowNumber } = useRowLabel<{ link?: { label?: string } }>()
  return data?.link?.label || `Item ${String((rowNumber ?? 0) + 1).padStart(2, '0')}`
}
